import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=4e5704a2&scoped=true&"
import script from "./PartnerDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=4e5704a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5704a2",
  null
  
)

export default component.exports